import { useEffect, useCallback } from 'react';

const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes

export function useInactivity(onInactive: () => void): void {
  const handleActivity = useCallback(() => {
    if (window.inactivityTimer) {
      clearTimeout(window.inactivityTimer);
    }
    window.inactivityTimer = setTimeout(onInactive, INACTIVITY_TIMEOUT);
  }, [onInactive]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];

    // Set up initial timer and event listeners
    handleActivity();
    events.forEach((event) => document.addEventListener(event, handleActivity));

    // Cleanup function
    return () => {
      if (window.inactivityTimer) {
        clearTimeout(window.inactivityTimer);
      }
      events.forEach((event) => document.removeEventListener(event, handleActivity));
    };
  }, [handleActivity]);
}

declare global {
  interface Window {
    inactivityTimer?: NodeJS.Timeout;
  }
}
